import authRules from '../authRules';

const approveJobElements = (user) => {
  const { approveJEs } = user.securityLevels;
  if (approveJEs >= authRules.approveJobElements.approveJEs) {
      return true;
  } else {
      return false;
    }
  }

export default approveJobElements;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/approveJobElements.js